import isNodeInTree from "./isNodeInTree";

export default (tree, id) => {
  if (tree.id === id) {
    return tree;
  }
  return tree.children.find(c => isNodeInTree(c, id));
};
